import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer/Footer';
import FloatingCTA from './components/FloatingCTA/FloatingCTA';


// Home Page Components
import Hero from './components/Hero/Hero';
import Browse from './components/Browse/Browse';
import StudyLocally from './components/StudyLocally/StudyLocally';

import CallToAction from './components/CallToAction/CallToAction';

// About Us Pages
import AboutUsMain from './pages/AboutUs/AboutUsMain';
import OurHistory from './pages/AboutUs/OurHistory';
import MissionVision from './pages/AboutUs/MissionVision';
import InstitutionalValues from './pages/AboutUs/InstitutionalValues';
import AcademicCalendar from './pages/AboutUs/AcademicCalendar';
import InteractiveMap from './pages/AboutUs/InteractiveMap';
import Testimonials from './pages/AboutUs/Testimonials';

// Services Pages
import ServicesMain from './pages/AboutUs/Services/ServicesMain';
import AcademicProposal from './pages/AboutUs/Services/AcademicProposal';
import GraduationSeminar from './pages/AboutUs/Services/GraduationSeminar';
import Events from './pages/AboutUs/Services/Events';
import InternationalAgreements from './pages/AboutUs/Services/InternationalAgreements';
import StudyAbroad from './pages/AboutUs/Services/StudyAbroad';
import SocialService from './pages/AboutUs/Services/SocialService';
import ScholarshipProgram from './pages/AboutUs/Services/ScholarshipProgram';
import PathwayProgram from './pages/AboutUs/Services/PathwayProgram';
import Entrepreneurship from './pages/AboutUs/Services/Entrepreneurship';
import StudentWellbeing from './pages/AboutUs/Services/StudentWellbeing';

// Courses Pages
import CoursesMain from './pages/AboutUs/Courses/CoursesMain';
import LevelUp from './pages/AboutUs/Courses/LevelUp';
import MasteringEnglish from './pages/AboutUs/Courses/MasteringEnglish';
import StandardizedTests from './pages/AboutUs/Courses/StandardizedTests';
import PublicSpeaking from './pages/AboutUs/Courses/PublicSpeaking';
import CorporateEnglish from './pages/AboutUs/Courses/CorporateEnglish';
import FrenchClasses from './pages/AboutUs/Courses/FrenchClasses';

import Admissions from './pages/Admissions';
import ScholarshipCalculator from './pages/Scholarships/ScholarshipCalculator';
import Faculty from './pages/Faculty';

// Library Pages


// Other About Us Pages

//Alumni
import AlumniSection from './pages/Alumni';

//Social Outreach

import SocialOutreachSection from './pages/SocialOutreach';

// Research 

import Research from './pages/Research';
import JournalArchive from './pages/JournalArchive';

//courses
import Courses from './pages/Courses';




// Actualizar el tema con los colores institucionales de American College
const theme = createTheme({
  palette: {
    primary: {
      main: '#2B2B6B', // Azul institucional
      light: '#3d3d8f',
      dark: '#1a1a4a',
    },
    secondary: {
      main: '#E31E24', // Rojo institucional
      light: '#f87171',
      dark: '#C41A1F',
    },
    info: {
      main: '#00CED1', // Turquesa (accent)
      light: '#4dd4d6',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F5F5F5',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
  },
});

// Componente de la página Home con todos los componentes de la landing
const HomePage = () => {
  return (
    <>
      <Hero />
      <Browse />
      <StudyLocally />
      <CallToAction />
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <FloatingCTA />
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<HomePage />} />

          {/* About Us - Main Section */}
          <Route path="/about-us" element={<AboutUsMain />} />
          <Route path="/about-us/history" element={<OurHistory />} />
          <Route path="/about-us/mission-vision" element={<MissionVision />} />
          <Route path="/about-us/courses" element={<Courses />} />
          <Route path="/about-us/values" element={<InstitutionalValues />} />
          <Route path="/about-us/calendar" element={<AcademicCalendar />} />

          {/* About Us - Services */}
          <Route path="/about-us/services" element={<ServicesMain />} />
          <Route path="/about-us/services/academic" element={<AcademicProposal />} />
          <Route path="/about-us/services/graduation" element={<GraduationSeminar />} />
          <Route path="/about-us/services/events" element={<Events />} />
          <Route path="/about-us/services/international" element={<InternationalAgreements />} />
          <Route path="/about-us/services/study-abroad" element={<StudyAbroad />} />
          <Route path="/about-us/services/social-service" element={<SocialService />} />
          <Route path="/about-us/services/scholarships" element={<ScholarshipProgram />} />
          <Route path="/about-us/services/pathway" element={<PathwayProgram />} />
          <Route path="/about-us/services/entrepreneurship" element={<Entrepreneurship />} />
          <Route path="/about-us/services/wellbeing" element={<StudentWellbeing />} />

          {/* About Us - Courses */}
          <Route path="/about-us/courses" element={<CoursesMain />} />
          <Route path="/about-us/courses/level-up" element={<LevelUp />} />
          <Route path="/about-us/courses/mastering-english" element={<MasteringEnglish />} />
          <Route path="/about-us/courses/standardized-tests" element={<StandardizedTests />} />
          <Route path="/about-us/courses/public-speaking" element={<PublicSpeaking />} />
          <Route path="/about-us/courses/corporate" element={<CorporateEnglish />} />
          <Route path="/about-us/courses/french" element={<FrenchClasses />} />

          
          <Route path="/about-us/admissions" element={<Admissions />} />
          <Route path="/about-us/map" element={<InteractiveMap />} />
          <Route path="/scholarships/calculator" element={<ScholarshipCalculator />} />
          <Route path="/faculty" element={<Faculty />} />

          

          {/* About Us - Library */}
          

          {/* About Us - Testimonials */} 
         <Route path="/about-us/testimonials" element={<Testimonials />} />

          {/* About Us - Regulations */}
         
         <Route path="/alumni" element={<AlumniSection />} />

         <Route path="/alumni" element={<AlumniSection />} />

         <Route path="/social-outreach" element={<SocialOutreachSection />} />  

        <Route path="/research" element={<Research />} />
       <Route path="/research/journal" element={<JournalArchive />} />

          {/* Otras secciones principales (por implementar) */}
          {/* <Route path="/academic-offering" element={<AcademicOffering />} /> */}
          {/* <Route path="/staff" element={<Staff />} /> */}
          {/* <Route path="/partnership" element={<Partnership />} /> */}
          {/* <Route path="/social-outreach" element={<SocialOutreach />} /> */}
          {/* <Route path="/contact" element={<Contact />} /> */}
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;